import { vservice } from '@niknevis/vue-modules'
import { RemoteData } from '@/modules/shared/helpers/http/remote-data'
import { AdminUserService } from '@/modules/user/services/admin-user.service'
import { UserResourceInAdminModel } from '@/modules/user/models/user-resource.model'
import { Data } from '@/modules/shared/models/data'

@vservice()
export class UserInfoGetUseCase {
  public remoteData = RemoteData
    .notAsked<Data<UserResourceInAdminModel>>()

  constructor(
    private readonly service: AdminUserService
  ) {
  }

  get isLoading() {
    return this.remoteData.isInProgress()
  }

  get data() {
    return this.remoteData.fold(
      () => null,
      value => value?.data || null,
      value => value.data,
      (error, value) => value?.data || null
    )
  }

  execute(userId: number): RemoteData<Data<UserResourceInAdminModel>> {
    return this.remoteData.fromPromise(
      this.service.userInfo(userId))
  }

}
